import styled from 'styled-components';

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
`;
